// Centralized configuration for card sizes based on content type
export interface CardSize {
  colSpan: number;
  rowSpan: number;
  className: string;
}

export const CARD_SIZES: Record<string, CardSize> = {
  image: {
    colSpan: 2,
    rowSpan: 2,
    className: 'md:col-span-2 md:row-span-2'
  },
  video: {
    colSpan: 2,
    rowSpan: 2,
    className: 'md:col-span-2 md:row-span-2'
  },
  infobox: {
    colSpan: 2,
    rowSpan: 1,
    className: 'md:col-span-2 md:row-span-1'
  },
  table: {
    colSpan: 2,
    rowSpan: 2,
    className: 'md:col-span-2 md:row-span-2'
  },
  code: {
    colSpan: 2,
    rowSpan: 2,
    className: 'md:col-span-2 md:row-span-2'
  },
  markdown: {
    colSpan: 2,
    rowSpan: 2,
    className: 'md:col-span-2 md:row-span-2'
  },
  action: {
    colSpan: 1,
    rowSpan: 2,
    className: 'md:col-span-1 md:row-span-2'
  },
  link: {
    colSpan: 1,
    rowSpan: 1,
    className: 'md:col-span-1 md:row-span-1'
  },
  default: {
    colSpan: 1,
    rowSpan: 2,
    className: 'md:col-span-1 md:row-span-2'
  }
};

export function getCardSize(type: string): CardSize {
  return CARD_SIZES[type] || CARD_SIZES.default;
} 